import {QueryClient, QueryClientProvider} from '@tanstack/react-query'
import {EnvironmentProvider} from 'providers/EnvironmentProvider'
import {OrderDetailsProvider} from 'providers/OrderDetailsProvider'
import {OrderProvider} from 'providers/OrderProvider'
import {Theme} from 'providers/Theme'
import {Screen} from './Screen'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
})

export const CartPreview = () => {
  return (
    <EnvironmentProvider>
      <Theme>
        <OrderDetailsProvider>
          <QueryClientProvider client={queryClient}>
            <OrderProvider>
              <Screen />
            </OrderProvider>
          </QueryClientProvider>
        </OrderDetailsProvider>
      </Theme>
    </EnvironmentProvider>
  )
}
